import styles from './_themeComponent.module.scss'
import { t } from '../../../utils/i18n'
import { songsPath } from '../../../utils/routeHelpers'
import { Theme } from '../../../__generated__/graphql'

interface ThemeProps {
  theme: Theme
  color: string
}

const ThemeComponent: React.FC<ThemeProps> = ({ theme, color }) => {
  return (
    <a href={songsPath({ themeIds: [theme.id] })} className={styles.themeItem}>
      <div className={`${styles.themeHolder} is-rectangle`}>
        <div
          className={styles.themeBackground}
          style={{ background: `${color}` }}
        />
        <div className={styles.themeName}>{theme.name}</div>
        <div className={styles.themeInfo}>
          <span>{theme.songsCount}</span>
          <span>{t('Songs')}</span>
        </div>
      </div>
    </a>
  )
}

export default ThemeComponent
